<template>
  <Teleport to="body">
    <ThanksPopup />
    <ErrorMessage />
    <LoadingScreen v-model="loading" />
  </Teleport>
  <div class="mnd-form" ref="root" v-if="shown">
    <SmoothWindow :slidecount="2" ref="partslider">
      <div class="mnd-form__mainpart mnd-step active">
        <div class="mnd-step__content">
          <h1 class="mnd-form__title">
            Застраховать квартиру за три шага:
          </h1>
          <Progress :stepcount="3" :currentstep="step" />
          <h2 class="mnd-form__title mnd-form__title_sm">
            {{ form.tariff }}
            <Tippy class="mnd-questionmark" :hideOnClick="true" :interactive="true" trigger="click" animation="scale" placement="bottom" :maxWidth="392" zIndex="99">
              <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                <circle cx="12" cy="12" r="11" fill="#D2D4DA" />
                <path d="M12.3659 13.88H11.1659C11.1659 13.44 11.3059 12.99 11.5859 12.53C11.8759 12.07 12.1859 11.675 12.5159 11.345C12.8559 11.005 13.1659 10.62 13.4459 10.19C13.7359 9.76 13.8809 9.355 13.8809 8.975C13.8809 8.005 13.1109 7.52 11.5709 7.52C10.6709 7.52 9.77092 7.785 8.87092 8.315V7.115C9.77092 6.585 10.7359 6.32 11.7659 6.32C12.7659 6.32 13.5809 6.54 14.2109 6.98C14.8409 7.41 15.1559 8.035 15.1559 8.855C15.1559 9.245 15.0609 9.635 14.8709 10.025C14.6809 10.415 14.4459 10.77 14.1659 11.09C13.8959 11.4 13.6209 11.705 13.3409 12.005C13.0709 12.305 12.8409 12.62 12.6509 12.95C12.4609 13.27 12.3659 13.58 12.3659 13.88ZM12.3209 15.815C12.4709 15.945 12.5459 16.13 12.5459 16.37C12.5459 16.61 12.4709 16.8 12.3209 16.94C12.1709 17.07 11.9859 17.135 11.7659 17.135C11.5459 17.135 11.3559 17.07 11.1959 16.94C11.0459 16.8 10.9709 16.61 10.9709 16.37C10.9709 16.13 11.0459 15.945 11.1959 15.815C11.3559 15.685 11.5459 15.62 11.7659 15.62C11.9859 15.62 12.1709 15.685 12.3209 15.815Z" fill="white" />
              </svg>
              <template #content>
                Более подробная информация об условиях страхования, в том числе исключениях из&nbsp;страхового покрытия, порядке и условиях выплаты страхового возмещения, содержится в&nbsp;<a class="mnd-newred" target="_blank" :href="tooltiplink">Правилах комплексного страхования имущества и сопутствующих рисков.</a>
              </template>
            </Tippy>
          </h2>
          <div class="mnd-form__window">
            <SmoothWindow :special="true" :slidecount="3" ref="slider" @slideChanged="this.step = $event" @finished="toCode">
              <Step1 ref="steps" :filledStatus="filledStatus" class="active" />
              <Step2 ref="steps" :filledStatus="filledStatus" />
              <Step3 @toSlide="($event) => $refs.slider.toSlide($event)" ref="steps" :filledStatus="filledStatus" />
            </SmoothWindow>
          </div>
          <Btn @click="() => $refs.slider.toSlide()" class="mnd-form__next" :disabled="notFilled">{{ btnText }}</Btn>
        </div>
      </div>
      <CodePart ref="codepart" />
    </SmoothWindow>
  </div>
</template>

<script>
import Progress from './components/Progress.vue'
import { Tippy } from 'vue-tippy'
import 'tippy.js/animations/scale.css'
import Btn from './components/ui/Btn.vue'
import { mapState, mapGetters } from 'vuex'
import Step1 from './components/steps/step1.vue'
import Step2 from './components/steps/step2.vue'
import Step3 from './components/steps/step3.vue'
import LoadingScreen from './components/LoadingScreen.vue'
import ThanksPopup from './components/ThanksPopup.vue'
import ErrorMessage from './components/ErrorMessage.vue'
import SmoothWindow from './components/SmoothWindow.vue'
import CodePart from './components/CodePart.vue'
export default {
  name: 'App',
  components: {
    Progress, Tippy,
    Btn,
    Step1,
    Step2,
    Step3, LoadingScreen, ThanksPopup, ErrorMessage,
    SmoothWindow, CodePart
  },
  data: () => ({
    shown: true,
    tooltiplink: './',
    filledStatus: {},
    step: 1
  }),
  methods: {
    toCode() {
      this.$refs.partslider.toSlide(2)
      this.$refs.codepart.sendCode(true)
    }
  },
  created() {
    const section = document.getElementById('app').closest('section')
    if (section) {
      const hh = document.querySelector('header.header')?.offsetHeight || 0
      document.querySelectorAll('.to_mnd_form').forEach(btn => btn.addEventListener('click', () =>
        window.scroll({ top: section.getBoundingClientRect().top + document.documentElement.scrollTop - hh, behavior: 'smooth' })
      ))
    }
    let ordernumber
    try {
      const lowParams = new URLSearchParams()
      for (const [name, value] of new URLSearchParams(window.location.search)) {
        lowParams.append(name.toLowerCase(), value)
      }
      ordernumber = lowParams.get('ordernumber')
    } catch (err) {
      let result = null, tmp = []
      location.search.substr(1).split("&").forEach(function (item) {
        tmp = item.split("=")
        if (tmp[0].toLowerCase() === 'ordernumber')
          result = decodeURIComponent(tmp[1])
      })
      ordernumber = result
    }
    if (ordernumber)
      this.$store.dispatch('success', ordernumber)
  },
  computed: {
    ...mapState(['form', 'sendedSuccessfully']),
    ...mapGetters(['loading']),
    btnText() {
      if (this.step < 3)
        return 'Оформить полис'
      else
        return 'Далее'
    },
    notFilled() {
      return !this.filledStatus[this.step]
    },
  },
  watch: {
    async sendedSuccessfully(v, old) {
      if (v && (v != old)) {
        const section = document.getElementById('app').closest('section')
        if (section) {
          section.style.setProperty('overflow', 'hidden')
          section.style.setProperty('height', section.offsetHeight + 'px')
          window.requestAnimationFrame(() => {
            window.requestAnimationFrame(() => {
              section.style.setProperty('transition', 'height 1s ease, padding 1s ease, opacity 1s ease')
              section.style.setProperty('height', '0px')
              section.style.setProperty('padding', '0px')
              section.style.setProperty('opacity', '0')
              section.style.setProperty('pointer-events', 'none')
            })
          })
        }
        setTimeout(() => this.shown = false, 1200)
      }
    }
  }
}
</script>

<style lang="sass">
.fade-enter-from,.fade-leave-to, .fastfade-enter-from,.fastfade-leave-to
  opacity: 0
  pointer-events: none
.fastfade-enter-active,.fastfade-leave-active
  transition: opacity .2s ease-out
.fade-enter-active,.fade-leave-active
  transition: background .5s ease, opacity .4s ease-out

.mnd-newred
  color: colors.$newred
.mnd-w500
  font-weight: 500
.mnd-mt0
  margin-top: 0 !important
.mnd-mt16
  margin-top: 16px
.mnd-questionmark
  cursor: pointer
  display: inline-block
  vertical-align: middle
.tippy-box
  border-radius: 8px
  background: white
  padding: 24px
  box-shadow:  0px 20px 40px 0px rgba(52, 53, 64, 0.10)
  font-size: 14px
  line-height: 1.14
  font-weight: 400
  text-align: left
  p:not(:last-child)
    margin-bottom: 8px
  @include for-mob
    padding: 12px

.mnd-form
  width: 100%
  box-shadow: 0px 20px 40px 0px rgba(52, 53, 64, 0.10)
  background: white
  padding: 80px 106px 64px
  & &__next
    margin: 45px auto 64px
  &__title
    padding-bottom: 21px
    margin-bottom: 0
    color: colors.$bluefont
    font-size: 36px
    text-align: center
    font-weight: 500
    line-height: 1.12
    &_sm
      padding: 12px 0
      font-size: 28px
      line-height: 1.14
      
  @include for-med
    padding: 40px
    &__title
      font-size: 30px
      &_sm
        font-size: 26px
  &__window
    padding: 32px 0

  @include for-mob
    padding: 32px 15px
    &__title
      font-size: 26px
      padding-bottom: 16px
      &_sm
        font-size: 22px
    &__window
      padding: 16px 0


    

</style>